import React, { Component } from 'react';
import Icon from '../../icons/Icon';
import CustomSelect from '../custom/CustomSelect';
import { SelectItem } from 'primereact/selectitem';
import UserService from '../../service/UserService';
import ServiceContainer from '../../config/ServiceContainer';
import { ServiceNames } from '../../constant/ServiceNames';
import { User, UserPreferences } from '../../domain/rbac/RbacDomains';
import MessageUtil from '../../util/MessageUtil';
import { DropdownChangeParams } from 'primereact/dropdown';
import LanguageUtil from '../../util/LanguageUtil';

class AccountPreferencesComponent extends Component<Props, State> {
  public state: State = new State();

  private readonly userService: UserService = ServiceContainer.getInstance().get(ServiceNames.USER);

  public render() {
    const { language, twoFA, fontSize } = this.state;
    return (
      <div className={'h-full w-full bg-white rounded-[10px] border border-[#BDBDBD] border-opacity-[0.5]'}>
        <div className={'text-2xl 2xl:text-3xl font-medium mx-[30px] my-[10px] text-f-black-2'}>
          {LanguageUtil.get({ id: 'common.label.preferences', defaultMessage: 'Preferences' })}
        </div>
        <div className={'bg-[#F6F8FA] h-[calc(100%-50px)] w-full rounded-b-lg px-4 py-4'}>
          <div className={'w-full flex flex-col items-center justify-center bg-[#F6F8FA] rounded-b-lg'}>
            <div className={'mt-[20px] w-11/12'}>
              <CustomSelect
                labelClassName={'bg-[#F6F8FA]'}
                value={twoFA}
                options={this.get2FATypeOptions()}
                onChange={(item) => this.setState({ twoFA: item.value })}
                label={'2FA'}
                backgroundColor={'bg-white'}
              />
            </div>
            <div className={'mt-[20px] w-11/12'}>
              <CustomSelect
                disabled={false}
                labelClassName={'bg-[#F6F8FA]'}
                value={language}
                options={this.getLanguageTypeOptions()}
                onChange={(item) => this.setState({ language: item.value })}
                label={LanguageUtil.get({ id: 'common.label.language', defaultMessage: 'Language' })}
                backgroundColor={'bg-white'}
              />
            </div>
            <div className={'mt-[20px] w-11/12'}>
              <CustomSelect
                labelClassName={'bg-[#F6F8FA]'}
                value={fontSize}
                options={this.getFontSizeOptions()}
                onChange={this.onChangeFontSize}
                label={LanguageUtil.get({ id: 'common.label.fontSize', defaultMessage: 'Font Size' })}
                backgroundColor={'bg-white'}
              />
            </div>
            <div className={'mt-[20px] w-11/12'}>
              <button onClick={this.updateUser} className={'bg-primary text-white h-[34px] w-full text-sm'}>
                <Icon icon={'rollback'} size={16} />
                {LanguageUtil.get({ id: 'common.label.update', defaultMessage: 'Update' })}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const { user } = this.props;
    const fontSize = user.preferences.fontSize;
    this.setState({
      twoFA: user.preferences?.twoFA,
      language: user.preferences?.language,
      fontSize: fontSize ?? '16px',
    });
  }

  private get2FATypeOptions(): SelectItem[] {
    return [
      { label: LanguageUtil.get({ id: 'common.label.enable', defaultMessage: 'Enable' }), value: true },
      { label: LanguageUtil.get({ id: 'common.label.disable', defaultMessage: 'Disable' }), value: false },
    ];
  }

  private getLanguageTypeOptions(): SelectItem[] {
    return [
      { label: LanguageUtil.get({ id: 'common.label.enUs', defaultMessage: 'English' }), value: 'en-US' },
      { label: LanguageUtil.get({ id: 'common.label.trTr', defaultMessage: 'Turkish' }), value: 'tr-TR' },
      { label: LanguageUtil.get({ id: 'common.label.uzbek', defaultMessage: 'Uzbek' }), value: 'uzbek' },
      { label: LanguageUtil.get({ id: 'common.label.ruRu', defaultMessage: 'Russian' }), value: 'ru-RU' },
    ];
  }

  private getFontSizeOptions(): SelectItem[] {
    return [
      { label: LanguageUtil.get({ id: 'common.label.small', defaultMessage: 'Small' }), value: '14px' },
      { label: LanguageUtil.get({ id: 'common.label.medium', defaultMessage: 'Medium' }), value: '16px' },
      { label: LanguageUtil.get({ id: 'common.label.large', defaultMessage: 'Large' }), value: '18px' },
    ];
  }

  private onChangeFontSize = (e: DropdownChangeParams): void => {
    this.setState({ fontSize: e.value });
  };

  private updateUser = () => {
    const { language, twoFA, fontSize } = this.state;
    const { user } = this.props;
    const preferences: UserPreferences = {
      timeZone: user.preferences.timeZone,
      twoFA: twoFA ?? user.preferences.twoFA,
      language: language ?? user.preferences.language,
      fontSize: fontSize ?? '16px',
    };
    this.userService.updatePreferences(preferences).then(() => {
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'messages.account.summaryPreferences', defaultMessage: 'Preferences' }),
        detail: <div>{LanguageUtil.get({ id: 'messages.account.success', defaultMessage: 'Success' })}</div>,
      });
      const htmlElement = document.getElementsByTagName('html')[0];
      htmlElement.style.fontSize = preferences.fontSize;
      window.location.reload();
    });
  };
}

interface Props {
  user: User;
}

class State {
  language: string | undefined;
  fontSize: string | undefined;
  twoFA: boolean | undefined;
}

export default AccountPreferencesComponent;
